import { renderApp } from './utils/utils';
import HelpBtn from './delivered';
import { getOrder } from './api/api';
import OrderDetailsPage from './order_details/OrderDetailsPage';
import { PAGES } from './constants/order_details';
import ReschedulerUpcoming from './order_details/ReschedulerUpcoming';
import { Provider } from 'react-redux';
import reducers from './order_details/reducers';
import configureStore from './utils/configure_store';
import { QueryClientProvider } from '@tanstack/react-query';
import { client } from '../../../components/rest/react-query';

const store = configureStore(reducers);
const ProviderWrapper = ({ children }) => (
  <Provider store={store}>{children}</Provider>
);

//UPCOMING:
renderApp(
  <OrderDetailsPage
    page={PAGES.upcoming}
    showFreeItem={true}
    getOrder={() => getOrder(window.orderId, 'all')}
    Provider={ProviderWrapper}
  />,
  'upcoming-app'
);

//ON THE WAY:
renderApp(
  <OrderDetailsPage
    page={PAGES.onTheWay}
    getOrder={() => getOrder(window.orderId, 'all')}
    Provider={ProviderWrapper}
  />,
  'on-the-way-app'
);

// DELIVERED
renderApp(
  <OrderDetailsPage
    page={PAGES.delivered}
    getOrder={() => getOrder(window.orderId, 'all')}
    Provider={ProviderWrapper}
  />,
  'delivered-app'
);

renderApp(<HelpBtn />, 'delivered-help-react-component');
renderApp(
  <QueryClientProvider client={client}>
    <ReschedulerUpcoming getOrder={() => getOrder(window.orderId, 'all')} />
  </QueryClientProvider>,
  'rescheduler-app'
);
